module.exports = __webpack_public_path__ + "static/media/preloader_button.1d5e95ed.gif";